ScoreTrekBattle.League = ScoreTrekBattle.League || {};
ScoreTrekBattle.League.Matchday = ScoreTrekBattle.League.Matchday || {};

ScoreTrekBattle.League.Matchday.LineupEditor = (function() {
    var _this, STATUS, CONFIG;

    CONFIG = {
        POINT_GAMES: ['game14', 'gameCarom'],
        SIDES: ['own', 'opponent'],
        VALUE_BYE: '__BYE__',
        VALUE_ADD: '__ADD__'
    };

    function resetStatus() {
        STATUS = {
            matchdayId: '',
            roundIndex: 0,
            homeSide: '',
            labels: {},
            players: {},
            rounds: [],
            dialog: null,
            resolve: function() {},
            reject: function() {}
        };
    }
    resetStatus();

    function load() {
        return Api.request('/battle/league/matchday/lineup', {
            id: STATUS.matchdayId
        }).then(result => {
            STATUS.homeSide = (result.matchday && result.matchday.homeSide) ? result.matchday.homeSide : 'own';
            STATUS.rounds = result.rounds || [];
            STATUS.labels = result.labels || {};
            STATUS.players = {};

            CONFIG.SIDES.forEach(side => {
                STATUS.players[side] = (result.players && result.players[side]) ? result.players[side] : [];
            });

            return result;
        });
    }

    function getRound() {
        return STATUS.rounds.find(round => {
            return (round.index === STATUS.roundIndex);
        }) || null;
    }

    function getSideState(round, side) {
        return (round && round.sides && round.sides[side]) ? round.sides[side] : null;
    }

    function getSideLabelKey(side) {
        return (side === STATUS.homeSide) ? 'home' : 'guest';
    }

    function getSquadLabel(side) {
        return STATUS.labels[side] || '';
    }

    function runSides(sides) {
        if (sides.length === 0) {
            return Promise.resolve();
        }

        return editSide(sides[0]).then(() => {
            return runSides(sides.slice(1));
        });
    }

    function editSide(side) {
        return new Promise(function(resolve, reject) {
            let round, state;

            round = getRound();
            state = getSideState(round, side);

            if ((round === null) || (state === null)) {
                resolve();
                return;
            }

            renderEditor(side, round, state).then($view => {
                showDialog(side, round, $view, resolve, reject);
            }).catch(reject);
        });
    }

    // Immer dieselben drei Knoepfe, damit der Dialog nicht die Bedienung
    // wechselt: festlegen, zuruecksetzen, abbrechen.
    function showDialog(side, round, $view, resolve, reject) {
        STATUS.dialog = chmDialog({
            title: __i18n('matchday/editor/title', {
                side: __i18n(`matchday/side/${getSideLabelKey(side)}`),
                round: round.name
            }, true),
            content: $view,
            large: true,
            isPersistant: true,
            allowActions: true,
            buttons: [
                {
                    label: __i18n('matchday/editor/button/commit'),
                    icon: '<i class="fa-solid fa-lock"></i>',
                    primary: true,
                    action: function() {
                        submit(side, round, $view).then(() => {
                            STATUS.dialog.close().then(resolve);
                        }).catch(error => {
                            showError($view, error);
                        });

                        return false;
                    }
                },
                {
                    label: __i18n('button/reset'),
                    icon: '<i class="fa-solid fa-rotate-left"></i>',
                    tertiary: true,
                    action: function() {
                        clearSlots($view, side);
                        showError($view, null);

                        return false;
                    }
                },
                {
                    label: __i18n('button/cancel'),
                    action: function() {
                        STATUS.dialog.close().then(resolve);
                    }
                }
            ]
        });
    }

    function clearSlots($view, side) {
        $view.find('.matchday-lineup-editor-slot').each(function() {
            setSlotValue($(this), '', side);
        });
    }

    /**
     * Was "Festlegen" bedeutet, entscheidet die Aufstellung selbst.
     *
     * Eine vollstaendige Aufstellung wird festgelegt. Eine leere nimmt die
     * Festlegung zurueck — ob sie ueber "Zuruecksetzen" geleert wurde oder von
     * Hand, macht keinen Unterschied. Alles dazwischen ist unfertig.
     */
    function submit(side, round, $view) {
        let $slots, emptyCount;

        $slots = $view.find('.matchday-lineup-editor-slot');
        emptyCount = $slots.filter('[data-is-set="no"]').length;

        if ((emptyCount > 0) && (emptyCount < $slots.length)) {
            return Promise.reject(new Error('MATCHDAY_LINEUP_INCOMPLETE'));
        }

        ScoreTrekBattle.View.loading('League.Matchday.LineupEditor.commit', true);

        return saveLineup(side, round, $view).then(() => {
            if (emptyCount > 0) {
                return null;
            }

            return Api.request('/battle/league/matchday/lineup/round/commit', {
                id: STATUS.matchdayId,
                roundIndex: round.index,
                side: side
            }).then(applyRounds);
        }).finally(() => {
            ScoreTrekBattle.View.loading('League.Matchday.LineupEditor.commit', false);
        });
    }

    // Eine bereits festgelegte Seite wird zuerst wieder geoeffnet — sonst
    // liesse sich an ihr nichts mehr speichern.
    function saveLineup(side, round, $view) {
        return unlockCommitted(side, round).then(() => {
            return Api.request('/battle/league/matchday/lineup/round/save', {
                id: STATUS.matchdayId,
                roundIndex: round.index,
                side: side,
                assignment: collectAssignment($view)
            });
        }).then(applyRounds);
    }

    function unlockCommitted(side, round) {
        let state;

        state = getSideState(getRound(), side);

        if (!state || !state.isCommitted) {
            return Promise.resolve(null);
        }

        return Api.request('/battle/league/matchday/lineup/round/unlock', {
            id: STATUS.matchdayId,
            roundIndex: round.index,
            side: side
        }).then(applyRounds);
    }

    function applyRounds(result) {
        if (result && result.rounds) {
            STATUS.rounds = result.rounds;
        }

        return result;
    }

    function collectAssignment($view) {
        let assignment;

        assignment = {};

        $view.find('[data-match-index]').each(function() {
            let matchIndex, playerIds;

            matchIndex = this.dataset.matchIndex;
            playerIds = [];

            $(this).find('.matchday-lineup-editor-slot').each(function() {
                if (isPlayerValue(this.dataset.playerId || '')) {
                    playerIds.push(this.dataset.playerId);
                }
            });

            if (playerIds.length > 0) {
                assignment[matchIndex] = playerIds;
            }
        });

        return assignment;
    }

    function showError($view, error) {
        let message;

        message = (error && error.message) ? __i18n(`error/${error.message}`) : String(error || '');

        $view.find('[data-id="error"]').css('display', message ? '' : 'none');
        $view.find('[data-id="errorText"]').text(message);
    }

    function renderEditor(side, round, state) {
        return ScoreTrekBattle.Template.render('league/matchday/lineup/editor', {
            side: side,
            sideLabel: getSideLabelKey(side),
            label: getSquadLabel(side),
            round: {
                index: round.index,
                name: round.name
            }
        }, true).then(view => {
            let roster;

            roster = STATUS.players[side] || [];

            view.$view.find('[data-id="rosterEmpty"]').css('display', (roster.length === 0) ? '' : 'none');

            return renderMatches(view.$view, side, round, state).then(() => {
                return view.$view;
            });
        });
    }

    function renderMatches($view, side, round, state) {
        let promises;

        promises = (round.matches || []).map(match => {
            return renderMatch(match, side, round, state);
        });

        return Promise.all(promises).then($matches => {
            $view.find('[data-id="matches"]').empty().append($matches);
        });
    }

    function renderMatch(match, side, round, state) {
        return ScoreTrekBattle.Template.render('league/matchday/lineup/editorMatch', {
            match: match
        }, true).then(view => {
            let slotCount, assigned, promises;

            view.$view.find('[data-id="gameType"]').text(__i18n(`gameType/${match.gameType}`));
            view.$view.find('[data-id="gameTarget"]').text(getTargetLabel(match));
            view.$view.find('[data-id="gameTypeIcon"]').css('background-image', `url('/res/img/game/${match.gameType}.svg')`);

            slotCount = getSlotCount(match, round);

            view.$view.attr('data-team-size', slotCount);
            view.$view.find('[data-id="playerType"]').text(getPlayerTypeLabel(slotCount));

            assigned = (state && state.assignment && state.assignment[match.index])
                ? state.assignment[match.index]
                : [];

            promises = [];

            for (let teamIndex = 0; teamIndex < slotCount; teamIndex++) {
                promises.push(renderSlot(teamIndex, assigned[teamIndex] || '', side));
            }

            return Promise.all(promises).then($slots => {
                view.$view.find('[data-id="slots"]').empty().append($slots);

                return view.$view;
            });
        });
    }

    function getSlotCount(match, round) {
        if (match.teamSize) {
            return Math.max(1, match.teamSize);
        }

        return Math.max(1, round.teamSize || 1);
    }

    function getPlayerTypeLabel(teamSize) {
        if (teamSize === 2) {
            return __i18n('playerType/short/double');
        }

        if (teamSize >= 3) {
            return __i18n('playerType/short/team');
        }

        return '';
    }

    function renderSlot(teamIndex, playerId, side) {
        return ScoreTrekBattle.Template.render('league/matchday/lineup/editorSlot', {
            slot: {
                teamIndex: teamIndex
            }
        }, true).then(view => {
            view.$view.on('click', function() {
                openSlotSelect($(this), side);
            });

            setSlotValue(view.$view, playerId, side);

            return view.$view;
        });
    }

    function setSlotValue($slot, value, side) {
        let player, label;

        player = findPlayer(side, value);

        if (player === null) {
            value = (value === CONFIG.VALUE_BYE) ? CONFIG.VALUE_BYE : '';
        }

        label = player
            ? player.fullName
            : ((value === CONFIG.VALUE_BYE) ? __i18n('player/bye') : __i18n('matchday/editor/choose'));

        $slot.attr({
            'data-player-id': value,
            'data-is-set': (value === '') ? 'no' : 'yes',
            'data-is-bye': (value === CONFIG.VALUE_BYE) ? 'yes' : 'no'
        });
        $slot.find('[data-id="playerLabel"]').text(label);
    }

    function applySlotValue($slot, value, side) {
        let $editor;

        $editor = $slot.closest('.matchday-lineup-editor');

        if (value === CONFIG.VALUE_ADD) {
            addPlayer($slot, side);
            return;
        }

        // Wo jemand pro Durchgang nur einmal antreten darf, wird er versetzt
        // statt ein zweites Mal gesetzt.
        if (isPlayerValue(value) && isOnePerRound()) {
            $editor.find('.matchday-lineup-editor-slot').each(function() {
                let $other;

                $other = $(this);

                if (!$other.is($slot) && ($other.attr('data-player-id') === value)) {
                    setSlotValue($other, '', side);
                }
            });
        }

        setSlotValue($slot, value, side);
    }

    function isPlayerValue(value) {
        return (value !== '') && (value !== CONFIG.VALUE_BYE) && (value !== CONFIG.VALUE_ADD);
    }

    function addPlayer($slot, side) {
        ScoreTrekBattle.League.Matchday.Roster.addPlayer(STATUS.matchdayId, side, {
            closeAfterAdd: true,
            getPlayers: function() {
                return STATUS.players[side] || [];
            },
            onAdded: function(player, players) {
                STATUS.players[side] = (players && players[side]) ? players[side] : STATUS.players[side];

                if (player) {
                    setSlotValue($slot, player.id, side);
                }
            }
        });
    }

    function findPlayer(side, playerId) {
        if (!isPlayerValue(playerId)) {
            return null;
        }

        return (STATUS.players[side] || []).find(player => {
            return (player.id === playerId);
        }) || null;
    }

    function openSlotSelect($slot, side) {
        let $editor, $match, current, gameType, matchIndex, used, exhausted, disciplines, partners, entries;

        $editor = $slot.closest('.matchday-lineup-editor');
        $match = $slot.closest('[data-match-index]');

        current = $slot.attr('data-player-id') || '';
        gameType = $match.attr('data-game-type') || '';
        matchIndex = parseInt($match.attr('data-match-index'), 10);

        used = collectUsedPlayerIds($editor);
        exhausted = collectExhaustedPlayerIds(side, used, current);
        disciplines = {};
        partners = collectPartnerPlayerIds($match, $slot);

        if (isDisciplineRestricted(parseInt($match.attr('data-team-size'), 10))) {
            disciplines = collectPlayedDisciplines(side);
            addCurrentRoundDisciplines(disciplines, $editor, $slot);
        }

        entries = [
            {
                value: '',
                render: function() {
                    return ScoreTrekBattle.League.Matchday.Roster.renderOption({
                        type: 'choose',
                        icon: '<i class="fa-solid fa-ellipsis"></i>',
                        label: __i18n('matchday/editor/choose')
                    });
                }
            },
            {
                value: CONFIG.VALUE_BYE,
                render: function() {
                    return ScoreTrekBattle.League.Matchday.Roster.renderOption({
                        type: 'bye',
                        icon: '<i class="fa-solid fa-user-slash"></i>',
                        label: __i18n('player/bye'),
                        note: __i18n('matchday/editor/byeNote')
                    });
                }
            },
            {
                value: CONFIG.VALUE_ADD,
                render: function() {
                    return ScoreTrekBattle.League.Matchday.Roster.renderOption({
                        type: 'add',
                        icon: '<i class="fa-solid fa-plus"></i>',
                        label: __i18n('matchday/editor/add/option'),
                        note: __i18n('matchday/editor/add/note')
                    });
                }
            }
        ];

        (STATUS.players[side] || []).forEach(player => {
            let blocked;

            blocked = getBlockedReason(player, current, gameType, exhausted, disciplines, partners);

            entries.push({
                value: player.id,
                blocked: blocked,
                render: function() {
                    return ScoreTrekBattle.League.Matchday.Roster.renderPlayer(player).then($item => {
                        let others;

                        if (blocked !== '') {
                            $item.find('.player').append(
                                $('<span>')
                                    .addClass('matchday-lineup-select-blocked')
                                    .text(__i18n(`matchday/editor/blocked/${blocked}`))
                            );

                            return $item;
                        }

                        others = (used[player.id] || []).filter(index => {
                            return (index !== matchIndex);
                        });

                        if (others.length > 0) {
                            $item.find('[data-id="roleName"]').append(
                                $('<span>').addClass('color-yellow ml-small').text(
                                    (others.length === 1)
                                        ? __i18n('matchday/editor/inMatch', {index: others[0]})
                                        : __i18n('matchday/editor/inMatches', {count: others.length})
                                )
                            );
                        }

                        return $item;
                    });
                }
            });
        });

        return Promise.all(entries.map(entry => entry.render())).then($items => {
            let dialog, chosen;

            chosen = null;

            dialog = chmSelect({
                title: __i18n('matchday/editor/select/title', {
                    index: matchIndex,
                    gameType: __i18n(`gameType/${gameType}`)
                }, true),
                isSearchable: ((STATUS.players[side] || []).length > 6),
                items: entries.map((entry, index) => {
                    return {
                        value: entry.value,
                        html: $items[index].addClass('matchday-lineup-select-item'),
                        attr: entry.blocked ? {'data-blocked': entry.blocked} : {},
                        isSelected: (entry.value === current)
                    };
                }),
                onSelect: function(value) {
                    chosen = value;
                }
            });

            dialog.afterClose(function() {
                if (chosen === null) {
                    return;
                }

                applySlotValue($slot, chosen, side);
            });
        });
    }

    function getBlockedReason(player, current, gameType, exhausted, disciplines, partners) {
        if (player.id === current) {
            return '';
        }

        if (exhausted[player.id] === true) {
            return 'limit';
        }

        if ((disciplines[player.id] || []).indexOf(gameType) >= 0) {
            return 'discipline';
        }

        // Im Doppel besetzt eine Person nur eine Seite des Teams — niemand ist
        // sein eigener Partner.
        if (partners[player.id] === true) {
            return 'partner';
        }

        return '';
    }

    // Je Person die Matches dieses Durchgangs, in denen sie gerade steht. Eine
    // Liste, weil eine Person ohne die Ein-Einsatz-Regel mehrfach vorkommen darf.
    function collectUsedPlayerIds($editor) {
        let used;

        used = {};

        $editor.find('.matchday-lineup-editor-slot').each(function() {
            let playerId, matchIndex;

            playerId = this.dataset.playerId || '';

            if (!isPlayerValue(playerId)) {
                return;
            }

            matchIndex = parseInt($(this).closest('[data-match-index]').attr('data-match-index'), 10);

            used[playerId] = used[playerId] || [];

            if (used[playerId].indexOf(matchIndex) < 0) {
                used[playerId].push(matchIndex);
            }
        });

        return used;
    }

    function collectPartnerPlayerIds($match, $slot) {
        let partners;

        partners = {};

        $match.find('.matchday-lineup-editor-slot').each(function() {
            let playerId;

            playerId = this.dataset.playerId || '';

            if ($slot.is(this) || !isPlayerValue(playerId)) {
                return;
            }

            partners[playerId] = true;
        });

        return partners;
    }

    function collectExhaustedPlayerIds(side, used, current) {
        let limit, usage, exhausted;

        limit = getMatchesPerPlayer();
        exhausted = {};

        if (limit <= 0) {
            return exhausted;
        }

        usage = {};

        STATUS.rounds.forEach(round => {
            let state;

            if (round.index === STATUS.roundIndex) {
                return;
            }

            state = getSideState(round, side);

            if (!state || !state.assignment) {
                return;
            }

            Object.values(state.assignment).forEach(playerIds => {
                playerIds.forEach(playerId => {
                    usage[playerId] = (usage[playerId] || 0) + 1;
                });
            });
        });

        Object.keys(usage).forEach(playerId => {
            let inThisRound;

            inThisRound = used[playerId] ? used[playerId].length : 0;

            // Mit der Ein-Einsatz-Regel wird eine schon gesetzte Person durch
            // die Auswahl versetzt, nicht ergaenzt — sie bleibt deshalb
            // waehlbar. Ohne die Regel kommt jede Auswahl obendrauf; dann zaehlt
            // nur der Platz nicht mit, der gerade bearbeitet wird.
            if (isOnePerRound()) {
                exhausted[playerId] = ((usage[playerId] + inThisRound) >= limit) && (inThisRound === 0);
                return;
            }

            exhausted[playerId] = ((usage[playerId] + inThisRound - ((playerId === current) ? 1 : 0)) >= limit);
        });

        return exhausted;
    }

    function collectPlayedDisciplines(side) {
        let disciplines;

        disciplines = {};

        STATUS.rounds.forEach(round => {
            let state;

            if (round.index === STATUS.roundIndex) {
                return;
            }

            state = getSideState(round, side);

            if (!state || !state.assignment) {
                return;
            }

            Object.keys(state.assignment).forEach(matchIndex => {
                let match;

                match = (round.matches || []).find(entry => {
                    return (entry.index === parseInt(matchIndex, 10));
                });

                if (!match || !isDisciplineRestricted(getSlotCount(match, round))) {
                    return;
                }

                state.assignment[matchIndex].forEach(playerId => {
                    disciplines[playerId] = disciplines[playerId] || [];

                    if (disciplines[playerId].indexOf(match.gameType) < 0) {
                        disciplines[playerId].push(match.gameType);
                    }
                });
            });
        });

        return disciplines;
    }

    // Ohne die Ein-Einsatz-Regel kann dieselbe Disziplin auch innerhalb des
    // Durchgangs ein zweites Mal zusammenkommen — die Plaetze dieses Durchgangs
    // stehen noch nicht in STATUS.rounds, sondern nur im Editor.
    function addCurrentRoundDisciplines(disciplines, $editor, $slot) {
        if (isOnePerRound()) {
            return;
        }

        $editor.find('.matchday-lineup-editor-slot').each(function() {
            let playerId, $match, gameType;

            playerId = this.dataset.playerId || '';

            if ($slot.is(this) || !isPlayerValue(playerId)) {
                return;
            }

            $match = $(this).closest('[data-match-index]');
            gameType = $match.attr('data-game-type') || '';

            if ((gameType === '') || !isDisciplineRestricted(parseInt($match.attr('data-team-size'), 10))) {
                return;
            }

            disciplines[playerId] = disciplines[playerId] || [];

            if (disciplines[playerId].indexOf(gameType) < 0) {
                disciplines[playerId].push(gameType);
            }
        });
    }

    function isDisciplineRestricted(teamSize) {
        let round, rule;

        round = getRound();
        rule = round ? round.disciplineRule : '';

        if (rule === 'singles') {
            return ((teamSize || 1) === 1);
        }

        return (rule === 'all');
    }

    function isOnePerRound() {
        let round;

        round = getRound();

        return !round || (round.onePerRound !== false);
    }

    function getMatchesPerPlayer() {
        let round;

        round = getRound();

        return (round && round.matchesPerPlayer) ? round.matchesPerPlayer : 0;
    }

    function getTargetLabel(match) {
        if (!match.gameTarget) {
            return '';
        }

        return __i18n(
            (CONFIG.POINT_GAMES.indexOf(match.gameType) >= 0) ? 'matchday/match/points' : 'matchday/match/wins',
            {target: match.gameTarget}
        );
    }

    function unlockSides(matchdayId, roundIndex) {
        return CONFIG.SIDES.reduce((chain, side) => {
            return chain.then(() => {
                return Api.request('/battle/league/matchday/lineup/round/unlock', {
                    id: matchdayId,
                    roundIndex: roundIndex,
                    side: side
                });
            });
        }, Promise.resolve());
    }

    _this = {
        reopen: function(matchdayId, roundIndex) {
            ScoreTrekBattle.View.loading('League.Matchday.LineupEditor.reopen', true);

            return unlockSides(matchdayId, roundIndex).finally(() => {
                ScoreTrekBattle.View.loading('League.Matchday.LineupEditor.reopen', false);
            }).then(() => {
                return _this.open(matchdayId, roundIndex);
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
            });
        },

        // Ohne Seite werden beide nacheinander bearbeitet — das braucht nur das
        // Wiederoeffnen, sonst waehlt der Turnierleiter die Seite selbst.
        open: function(matchdayId, roundIndex, side) {
            resetStatus();

            STATUS.matchdayId = matchdayId;
            STATUS.roundIndex = roundIndex;

            ScoreTrekBattle.View.loading('League.Matchday.LineupEditor.open', true);

            return load().finally(() => {
                ScoreTrekBattle.View.loading('League.Matchday.LineupEditor.open', false);
            }).then(() => {
                return runSides(side ? [side] : CONFIG.SIDES);
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
            }).finally(() => {
                resetStatus();
            });
        }
    };

    return _this;
})();
